module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-1024x1024-themed-99d2141213005fc60e724ef08393017e.png";